import api from '@/api';
import Context from '@/models/Context';

const Uploader = function(file) {
  let data = new FormData();
  data.append('upload', file);

  const domain = Context.query().first().domain;

  return new Promise(resolve => {
    api.post(`/${domain}/uploads`, data).then(result => {
      const response = {
        type: resolveType(result.data.data.upload.mime_type),
        url: result.data.data.upload._links.data.href
      };

      resolve(response);
    });
  });
};

const resolveType = function(mime) {
  if (mime.indexOf('video') > -1) {
    return 'video';
  }

  if (mime.indexOf('image') > -1) {
    return 'image';
  }

  return 'other';
};

export default Uploader;
